import { Lookup } from "../../DrillDownMap"
import Geocoding from "../../classes/Geocoding"
import { DrillDownEvent } from "../../types"
import { calcAccumulateTime, calcTravelledDistance } from "../../utils/CalculateUtils"

export type Information = {
    title: string,
    value: string
}

export const iniInformations: Information[] = [
    {title: "Event time (UTC-0)", value:"--"},
    {title: "Event time (User TZ)", value:"--"},
    {title: "Address", value:"--"},
    {title: "Coordinates", value:"--"},
    {title: "Cumulate distance", value:"--"},
    {title: "Cumulate time", value:"--"},
    {title: "Speed", value:"--"}
]

export const buildInformation = async (geocoding: Geocoding, eventActive: DrillDownEvent, events: DrillDownEvent[] = []): Promise<Information[]> => {
    
    const aux = [...iniInformations]

    if(eventActive === undefined || eventActive === null) return aux

    const {speed, lat, lng, params, timestamp, user_time} = eventActive
    const latLng = {lat,lng}
    let address;
    let accumulateTime = "--";
    let accumulateDistance;

    
    let timestampFormated = new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Etc/UTC',
    }).format(timestamp);

    if(geocoding){
        await geocoding.fillAddresses([latLng])    
        address = geocoding.getAddress(latLng);        
    }
    
    let index = events.findIndex(ele => ele.id === eventActive.id)

    if(index !== -1){
        const sliceEvents = events.slice(0, index+1);
        accumulateTime = calcAccumulateTime(sliceEvents)
        accumulateDistance = calcTravelledDistance(sliceEvents).toFixed(1).toString()
    }
    
    aux[0].value = timestamp ? timestampFormated : aux[0].value
    aux[1].value = user_time || aux[1].value
    aux[2].value = address ? address : aux[1].value
    aux[3].value = latLng ? `${lat}, ${lng}` : aux[2].value
    aux[4].value = (accumulateDistance ? accumulateDistance + "Km" : aux[3].value)
    aux[5].value = (accumulateTime ? accumulateTime : accumulateTime === "" ? "--" :aux[4].value)
    aux[6].value = (speed ? speed?.toFixed(1).toString() + "Km/h" : aux[5].value)

    if(params){
        Object.keys(params).forEach(key => {
            const {title, value = "--"} = params[key]
            aux.push({title, value})
        })
    }

    return aux
}


export const UNINITIALIZED_SPAN = -1

export const SELECTED_POLYLINE_WEIGHT = 20

export const DEFAULT_POLYLINE_WEIGHT = 8